import { gql, NetworkStatus, useQuery } from "@apollo/client";
import { shiftStreamClient } from "./client";

export const GET_CLIENTS = gql`
  query getClients {
    clients {
      id
      accountName
    }
  }
`;

export const useClients = () => {
  const { data, loading, networkStatus } = useQuery(GET_CLIENTS, {
    client: shiftStreamClient,
    variables: {},
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
    onError: error => {
      throw error;
    }
  });

  const resolvedData = data;

  return {
    loading: loading || networkStatus === NetworkStatus.refetch,
    clients: resolvedData?.clients || []
  };
};
